// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Общий контейнер === */
.FiscalChecks_tableWrapper__NwoRY {
  overflow-x: auto;
  max-height: calc(100vh - 240px);
  overflow-y: auto;
  padding-right: 6px;
}

/* === Таблица === */
.FiscalChecks_table__NWSSc {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  font-size: 13px;
}

.FiscalChecks_table__NWSSc th {
  background: #f5f6fa;
  text-align: left;
  padding: 8px 10px;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
}

.FiscalChecks_table__NWSSc td {
  padding: 8px 10px;
  border-bottom: 1px solid #f0f0f0;
  color: #444;
}

.FiscalChecks_table__NWSSc tr:hover {
  background: #fafafa;
}

.FiscalChecks_issued__Shil9 {
  color: #388e3c;
  font-weight: 600;
}

.FiscalChecks_scanCell__wG1r\\+ {
  color: #1565c0;
  cursor: pointer;
  font-weight: 600;
  transition: color 0.2s ease;
}
.FiscalChecks_scanCell__wG1r\\+:hover {
  color: #0d47a1;
}

.FiscalChecks_issueBtn__kwerp {
  background: #4caf50;
  border: none;
  border-radius: 6px;
  color: #fff;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s ease;
}
.FiscalChecks_issueBtn__kwerp:hover {
  background: #43a047;
}

/* === Карточки === */
.FiscalChecks_cardsWrapper__UU7SD {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 12px;
  max-height: calc(100vh - 240px);
  overflow-y: auto;
  padding-right: 6px;
}

.FiscalChecks_receiptCard__l2oe4 {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: all 0.2s ease;
}

.FiscalChecks_receiptCard__l2oe4:hover {
  transform: translateY(-2px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
}

.FiscalChecks_issuedCard__7\\+71I {
  background: #f1f8e9;
  border: 1px solid #aed581;
}

.FiscalChecks_receiptHeader__uqoTG {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #333;
}

.FiscalChecks_routeTag__FrftZ {
  color: #3f51b5;
}

.FiscalChecks_receiptBody__Js9d0 {
  font-size: 13px;
  color: #444;
  line-height: 1.4;
}

.FiscalChecks_receiptBody__Js9d0 p {
  margin: 2px 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.FiscalChecks_scanInfo__IaZv1 {
  color: #1565c0;
  cursor: pointer;
  font-weight: 600;
  transition: color 0.2s ease;
}
.FiscalChecks_scanInfo__IaZv1:hover {
  color: #0d47a1;
}

.FiscalChecks_receiptActions__Z1R2U {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
}

.FiscalChecks_disabledBtn__bFLJT {
  background: #9e9e9e !important;
  cursor: default !important;
}

/* === Переключатели === */
.FiscalChecks_viewSwitch__2RuCs {
  display: flex;
  gap: 6px;
  margin-left: 10px;
}

.FiscalChecks_switchBtn__8fK6n {
  background: #f9fafc;
  border: 1px solid #cbd3e1;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.FiscalChecks_switchBtn__8fK6n:hover {
  background: #e8eaf6;
}

.FiscalChecks_switchBtn__8fK6n.FiscalChecks_active__udZp9 {
  background: #3f51b5;
  color: #fff;
  border-color: #3f51b5;
}

/* === Состояния загрузки и пустоты === */
p {
  color: #444;
  font-size: 14px;
  text-align: center;
  margin-top: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Dispatcher/FiscalChecks/FiscalChecks.module.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["/* === Общий контейнер === */\r\n.tableWrapper {\r\n  overflow-x: auto;\r\n  max-height: calc(100vh - 240px);\r\n  overflow-y: auto;\r\n  padding-right: 6px;\r\n}\r\n\r\n/* === Таблица === */\r\n.table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\r\n  font-size: 13px;\r\n}\r\n\r\n.table th {\r\n  background: #f5f6fa;\r\n  text-align: left;\r\n  padding: 8px 10px;\r\n  font-weight: 600;\r\n  color: #333;\r\n  border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.table td {\r\n  padding: 8px 10px;\r\n  border-bottom: 1px solid #f0f0f0;\r\n  color: #444;\r\n}\r\n\r\n.table tr:hover {\r\n  background: #fafafa;\r\n}\r\n\r\n.issued {\r\n  color: #388e3c;\r\n  font-weight: 600;\r\n}\r\n\r\n.scanCell {\r\n  color: #1565c0;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  transition: color 0.2s ease;\r\n}\r\n.scanCell:hover {\r\n  color: #0d47a1;\r\n}\r\n\r\n.issueBtn {\r\n  background: #4caf50;\r\n  border: none;\r\n  border-radius: 6px;\r\n  color: #fff;\r\n  padding: 6px 12px;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  transition: all 0.2s ease;\r\n}\r\n.issueBtn:hover {\r\n  background: #43a047;\r\n}\r\n\r\n/* === Карточки === */\r\n.cardsWrapper {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));\r\n  gap: 12px;\r\n  max-height: calc(100vh - 240px);\r\n  overflow-y: auto;\r\n  padding-right: 6px;\r\n}\r\n\r\n.receiptCard {\r\n  background: #fff;\r\n  border-radius: 10px;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\r\n  padding: 12px 14px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.receiptCard:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.issuedCard {\r\n  background: #f1f8e9;\r\n  border: 1px solid #aed581;\r\n}\r\n\r\n.receiptHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  margin-bottom: 6px;\r\n  color: #333;\r\n}\r\n\r\n.routeTag {\r\n  color: #3f51b5;\r\n}\r\n\r\n.receiptBody {\r\n  font-size: 13px;\r\n  color: #444;\r\n  line-height: 1.4;\r\n}\r\n\r\n.receiptBody p {\r\n  margin: 2px 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.scanInfo {\r\n  color: #1565c0;\r\n  cursor: pointer;\r\n  font-weight: 600;\r\n  transition: color 0.2s ease;\r\n}\r\n.scanInfo:hover {\r\n  color: #0d47a1;\r\n}\r\n\r\n.receiptActions {\r\n  margin-top: 8px;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.disabledBtn {\r\n  background: #9e9e9e !important;\r\n  cursor: default !important;\r\n}\r\n\r\n/* === Переключатели === */\r\n.viewSwitch {\r\n  display: flex;\r\n  gap: 6px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.switchBtn {\r\n  background: #f9fafc;\r\n  border: 1px solid #cbd3e1;\r\n  border-radius: 6px;\r\n  padding: 6px 10px;\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.switchBtn:hover {\r\n  background: #e8eaf6;\r\n}\r\n\r\n.switchBtn.active {\r\n  background: #3f51b5;\r\n  color: #fff;\r\n  border-color: #3f51b5;\r\n}\r\n\r\n/* === Состояния загрузки и пустоты === */\r\np {\r\n  color: #444;\r\n  font-size: 14px;\r\n  text-align: center;\r\n  margin-top: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableWrapper": `FiscalChecks_tableWrapper__NwoRY`,
	"table": `FiscalChecks_table__NWSSc`,
	"issued": `FiscalChecks_issued__Shil9`,
	"scanCell": `FiscalChecks_scanCell__wG1r+`,
	"issueBtn": `FiscalChecks_issueBtn__kwerp`,
	"cardsWrapper": `FiscalChecks_cardsWrapper__UU7SD`,
	"receiptCard": `FiscalChecks_receiptCard__l2oe4`,
	"issuedCard": `FiscalChecks_issuedCard__7+71I`,
	"receiptHeader": `FiscalChecks_receiptHeader__uqoTG`,
	"routeTag": `FiscalChecks_routeTag__FrftZ`,
	"receiptBody": `FiscalChecks_receiptBody__Js9d0`,
	"scanInfo": `FiscalChecks_scanInfo__IaZv1`,
	"receiptActions": `FiscalChecks_receiptActions__Z1R2U`,
	"disabledBtn": `FiscalChecks_disabledBtn__bFLJT`,
	"viewSwitch": `FiscalChecks_viewSwitch__2RuCs`,
	"switchBtn": `FiscalChecks_switchBtn__8fK6n`,
	"active": `FiscalChecks_active__udZp9`
};
export default ___CSS_LOADER_EXPORT___;
